<template>
	<div v-loading="!dataReady" class="order room__block" v-if="orderShow">
		<div v-if="!payListShow" class="order__panel">
			<div class="order__header">
				<img class="global_pointer" @click="close" :src="require('@/assets/imgs/close.png')" />
			</div>
			<div class="order__body">
				<div class="order__good">
					<template v-for="(item, index) in checked">
						<div
							:key="item.id + 'body'"
							class="order__good_unit"
							:class="{ 'order__good_unit-top': index > 0 }"
						>
							<img
								class="order__good_poster"
								:src="item.merchandiseImg.url"
							/>
							<div class="order__good_info">
								<div class="order__good_name">
									{{ item.merchandiseName }}
								</div>
								<div class="order__good_price">
									<div class="order__good_price-text">
										{{ item.miniAmountMoney.symbol
										}}{{
											$currencyFormatter(
												item.miniAmountMoney.number
											)
										}}
									</div>
								</div>
								<div class="order__good_sku">
									{{ item.skuText }}
								</div>
								<div class="order__good_inner">
									<div
										v-if="item.supportRefund == 0"
										class="order__good__refund"
									>
										{{ $t("message.goods.refund") }}
									</div>
									<div v-else></div>
									<div class="order__good__num_area">
										<div
											class="order__good__sub global_pointer"
											@click="sub(index)"
										>
											-
										</div>
										<div class="order__good__num">
											{{ item.buyNum }}
										</div>
										<div
											class="order__good__add global_pointer"
											@click="add(index)"
										>
											+
										</div>
									</div>
								</div>
							</div>
						</div>
						<div :key="item.id + 'input'" class="order__good_desc">
							<input
								v-model="item.remark"
								:placeholder="$t('message.order.goodsDesc')"
							/>
						</div>
						<div :key="item.id + 'divider'" class="divider"></div>
					</template>
				</div>
				<!-- <div class="order__good_email">
          <img
            :src="require('@/assets/imgs/goods/email.png')"
            class="order__addr_icon"
          />
          <span class="required">*</span>
          <input
            v-model="dataForm.email"
            :placeholder="$t('message.order.email')"
          />
        </div> -->
				<div class="divider"></div>
				<div class="order__addr global_pointer" @click="showAddrList">
					<img
						:src="require('@/assets/imgs/goods/location.png')"
						class="order__addr_icon"
					/>
					<div class="order__addr_text">
						<span class="required">*</span>
						<div v-if="addrText">{{ addrText }}</div>
						<div v-else class="order__addr_placeholder">
							{{ $t("message.order.setAddress") }}
						</div>
					</div>
					<img
						:src="require('@/assets/imgs/goods/arrow.png')"
						class="order__addr_arrow"
					/>
				</div>
				<div class="divider"></div>
				<div class="order__off">
					<div class="order__off_ticket global_pointer" @click="couponClick">
						<img
							:src="require('@/assets/imgs/goods/ticket.png')"
							class="order__off_icon"
						/>
						<div class="order__off_text">
							<!-- <span class="required">*</span>  -->
							<span
								v-if="bestTicketInfo && bestTicketInfo.ticket"
								>{{ bestTicketInfo.ticket.ticketName }}
							</span>

							<span v-else class="order__off_placeholder">
								{{ $t("message.order.coupon") }}
							</span>

							<span v-if="bestTicketInfo && bestTicketInfo.ticket" class="order__off_text_discount" >
								
								<template v-if="
									(bestTicketInfo.ticket.ticketType === 1 ||
									bestTicketInfo.ticket.ticketType === 3) &&
									bestTicketInfo.ticket.discountMoneyMoney
								">
									-<span class="symbol">{{
									bestTicketInfo.ticket.discountMoneyMoney.symbol
									}}</span>
									<span class="num">{{
									bestTicketInfo.ticket.discountMoneyMoney.number
									}}</span>
								</template>

								<template v-if="bestTicketInfo.ticket.ticketType === 2">
									<template>
										<span class="num" v-if=" $i18n.locale === 'en' ">{{ (100-bestTicketInfo.ticket.discountRate*100) }}</span>
										<span class="num" v-else>{{ bestTicketInfo.ticket.discountRate * 10 }}</span>
										<span class="symbol">{{ $t("message.shop.coupon.discount") }}</span>
									</template>
									<!-- <template v-else>
										<span class="num">{{ 100 - bestTicketInfo.ticket.discountRate * 100 }}</span>
										<span class="symbol">%</span>
									</template> -->
								</template>


								<!-- {{
									"-" + bestTicketInfo.ticket.discountMoneyMoney.symbol + " " 
									+ $currencyFormatter( bestTicketInfo.ticket.discountMoneyMoney.number )
								}} -->
							</span>
						</div>
						<img
							:src="require('@/assets/imgs/goods/arrow.png')"
							class="order__off_arrow"
						/>
					</div>
					<div class="order__off_code">
						<span>{{ $t("message.order.couponCode") }}</span>
						<div class="order__off_input">
							<input
								v-model="offCodeVal"
								:placeholder="
									$t('message.order.inputCouponCode')
								"
							/>
						</div>
						<div class="order__off_btn global_pointer" @click="getCouponcode">
							{{ $t("message.order.use") }}
						</div>
					</div>
					<div class="divider"></div>
				</div>
				<div class="order__note">
					<input
						v-model="dataForm.orderNote"
						:placeholder="$t('message.order.orderDesc')"
					/>
					<div class="divider"></div>
				</div>
				<div v-if="someMoneyReady" class="order__info">
					<div class="order__info_item">
						<span>{{ $t("message.order.price") }}</span>
						<span
							>{{ someMoney.merchandiseAllMoney.symbol
							}}{{
								$currencyFormatter(
									someMoney.merchandiseAllMoney.number
								)
							}}</span
						>
					</div>
					<div class="order__info_item">
						<span>{{ $t("message.order.Tax") }}</span>
						<span
							>{{ someMoney.allTaxAmountMoney.symbol
							}}{{
								$currencyFormatter(
									someMoney.allTaxAmountMoney.number
								)
							}}</span
						>
					</div>
					<div class="order__info_item">
						<span>{{ $t("message.order.freight") }}</span>
						<span
							v-if="
								Number(someMoney.freightAmountMoney.number) > 0
							"
						>
							{{ someMoney.freightAmountMoney.symbol
							}}{{
								$currencyFormatter(
									someMoney.freightAmountMoney.number
								)
							}}
						</span>
						<span v-else>{{ $t("message.order.free") }}</span>
					</div>
                    <div class="order__info_item" v-if="
                        someMoney.orderServiceFeeInfo && someMoney.orderServiceFeeInfo.serviceFeeAmountMoney && someMoney.orderServiceFeeInfo.serviceFeeAmountMoney.number
                    ">
						<div class="service-fee">
                            <span>{{ $t("message.order.serviceFee") }}</span>
                            <img class="global_pointer" src="https://fr-static.shopshops.top/20220713/service-fee.0207d37433af11f5.png" alt="" @click="showServiceFee">
                        </div>
						<span>
							{{ someMoney.orderServiceFeeInfo.serviceFeeAmountMoney.symbol
							}}{{
								$currencyFormatter(
									someMoney.orderServiceFeeInfo.serviceFeeAmountMoney.number
								)
							}}
						</span>
					</div>
					<div
						v-if="someMoney.couponcodeSavePriceMoney.number != 0"
						class="order__info_item"
					>
						<span>{{ $t("message.order.DiscountCode") }}</span>
						<span
							>-{{ someMoney.couponcodeSavePriceMoney.symbol
							}}{{
								$currencyFormatter(
									someMoney.couponcodeSavePriceMoney.number
								)
							}}</span
						>
					</div>
					<div
						v-if="someMoney.ticketSavePriceMoney.number != 0"
						class="order__info_item"
					>
						<span>{{ $t("message.order.Promo") }}</span>
						<span
							>-{{ someMoney.ticketSavePriceMoney.symbol
							}}{{
								$currencyFormatter(
									someMoney.ticketSavePriceMoney.number
								)
							}}</span
						>
					</div>
					<div
						v-if="someMoney.disRankAmountMoney.number != 0"
						class="order__info_item"
					>
						<span>{{ $t("message.order.vipBenefit") }}</span>
						<span
							>-{{ someMoney.disRankAmountMoney.symbol
							}}{{
								$currencyFormatter(
									someMoney.disRankAmountMoney.number
								)
							}}</span
						>
					</div>
					<!-- <div class="order__info_item">
            <span>{{ $t('message.order.freight') }}</span>
            <span>+{{someMoney.freightAmountMoney.symbol}}{{Number(someMoney.freightAmountMoney.number).toFixed(2)}}</span>
          </div> -->
				</div>
				<div class="divider"></div>

				<!-- <div v-if="!en" class="order__rule" @click="changeRule">
					<img
						v-if="ruleChecked"
						:src="require('@/assets/imgs/login/checked.png')"
						class="order__rule_checkbox"
					/>
					<span class="order__rule_checkbox" v-else></span>
					<div class="order__rule_text">
						{{ $t("message.order.agree") }}
					</div>
				</div> -->

				<div v-if="!en" class="order__rule">
					<img
						@click="changeRule"
						v-if="ruleChecked"
						:src="require('@/assets/imgs/login/checked.png')"
						class="order__rule_checkbox"
					/>
					<span
						class="order__rule_checkbox global_pointer"
						@click="changeRule"
						v-else
					></span>
					<div class="order__rule_text">
						<span>我已同意并认可 ShopShops 哪逛平台服务</span>
						<span class="global_pointer" @click="selectRule('XiaoFeiZheGaoZhiShu')"
							>《消费者告知书》、</span
						>
						<span class="global_pointer" @click="selectRule('XiaoFeiZheZhiXiQueRen')"
							>《消费者知悉确认》、</span
						>
						<span class="global_pointer" @click="selectRule('ShenBaoWeiTuoFuWu')"
							>《申报委托服务》、</span
						>
						<span class="global_pointer" @click="selectRule('GuoJiPeiSongFuWu')"
							>《国际配送服务》</span
						>
						<span>等</span>
					</div>
				</div>

				<div class="order__total" v-if="someMoneyReady">
					<span class="order__total_title">{{
						$t("message.order.sumTotal")
					}}</span>
					<span class="order__total_val"
						>{{ someMoney.payAmountMoney.symbol
						}}{{
							$currencyFormatter(someMoney.payAmountMoney.number)
						}}</span
					>
				</div>
				<div @click="action" class="order__btn">
					{{ getActionText() }}
				</div>
			</div>
		</div>
		<pay-list
			v-if="payListShow"
			@choosePayType="choosePayType"
			@close="closePayList"
			:payAmountMoney="someMoney.payAmountMoney"
		/>
		<add-card
			v-if="addCardShow"
			@close="closeAddCard"
			@generateStripe="getStripe"
			@generatePayMethod="getPayMethod"
		/>
		<payResult v-if="payResultShow" @close="closePayResult"></payResult>

		<van-popup
			v-model="rulePopShow"
			round
			closeable
			position="bottom"
			:style="{ height: '380px' }"
		>
			<div class="order__rule_pop">
				<van-collapse v-model="activeRule" accordion>
					<van-collapse-item
						v-for="item in ruleList"
						:key="item.type"
						:title="item.title"
						:name="item.type"
					>
						<p v-html="item.content"></p>
					</van-collapse-item>
				</van-collapse>
			</div>
		</van-popup>

		<addressList
			v-if="addressListShow"
			@newAddr="newAddr"
			@editAddr="editAddr"
			@selectAddr="selectAddr"
			@close="closeAddrList"
		/>
		<addressInfo
			v-if="addressInfoShow"
			:id="editAddrId"
			@saveSuccess="saveAddrSuccess"
			@close="closeAddrInfo"
		/>
		<Coupon
			:canUse="canUse"
			:cannotUse="cannotUse"
			:couponView="couponView"
			:skus="checked"
			:goodList="checked"
			:addrId="addrId"
			:bestTicketInfo="bestTicketInfo"
			@discountInfo="getDiscountInfo"
			@closeClick="closeClick"
		/>
	</div>
</template>

<script>
import api from "@/api/api_list.js";
import payList from "@/components/shop/payList";
import Coupon from "@/components/shop/coupon/coupon";
import addCard from "@/components/shop/addCard";
import payResult from "@/components/shop/payResult";

import Popup from "vant/lib/popup";
import Dialog from "vant/lib/dialog";
import Collapse from "vant/lib/collapse";
import CollapseItem from "vant/lib/collapse-item";

import addressList from "@/components/address/list";
import addressInfo from "@/components/address/info";
import { plateForm } from '@/utils'

export default {
	props: {
		checked: {
			type: Array,
			default: () => {
				return [];
			},
		},
		liveId: {
			type: String,
			default: "",
		},
	},
	components: {
		payList,
		Coupon,
		addCard,
		payResult,
		[Popup.name]: Popup,
		[Collapse.name]: Collapse,
		[CollapseItem.name]: CollapseItem,
        [Dialog.name]: Dialog,
		addressInfo,
		addressList,
	},
	data() {
		return {
			orderShow: false,
			dataForm: {
				orderNote: "",
				payType: null,
				email: "",
			},
			addrId: "",
			offCodeVal: "",
			ruleChecked: true,
			addrText: "",
			someMoney: {},
			payListShow: false,
			someMoneyReady: false,
			ticketInfo: null,
			bestTicketInfo: null,
			totalMoney: {
				number: 0,
				symbol: "",
			},
			couponView: false,
			canUse: [],
			cannotUse: [],
			en: this.$i18n.locale === "en",

			// stripe 相关
			stripe: null,
			payMethod: null,
			addCardShow: false,
			payResultShow: false,
			dataReady: false,
			rulePopShow: false,
			activeRule: "",
			ruleList: [],
			// addr
			addressListShow: false,
			addressInfoShow: false,
			editAddrId: "",
		};
	},
	created() {
		this.init();
	},
	watch: {
		checked: {
			immediate: true,
			handler(val) {
				val.forEach((good) => {
					if (!good.num) {
						good.buyNum = good.buyNum || 1;
						good.priceMoney = good.miniAmountMoney;
						(good.num = good.buyNum || 1),
							(good.remark = good.remark || ""),
							(good.liveId = this.liveId);
					}
				});
			},
		},
		offCodeVal(val, older) {
			if (val == "" && older != "") {
				this.getDefaultAddr();
			}
		},
	},
	methods: {
        showServiceFee() {
            Dialog.alert({
                title: this.$t("message.order.serviceFee"),
                message: this.someMoney.orderServiceFeeInfo.serviceFeeTitle,
                confirmButtonText: this.$t('message.goods.confirm'),
                confirmButtonColor: '#333333'
            }).then(() => {
            // on close
            });
        },
		async init() {
			await this.settlementCheck();
			await this.getDefaultAddr();
			this.getRules();
			this.dataReady = true;
		},

		selectRule(type) {
			this.activeRule = type;
			this.rulePopShow = true;
		},

		async getRules() {
			const res = await api.list_content_by_key({
				typeIds: [
					"XiaoFeiZheGaoZhiShu",
					"XiaoFeiZheZhiXiQueRen",
					"ShenBaoWeiTuoFuWu",
					"GuoJiPeiSongFuWu",
				],
			});

			if (res.code === 0 && res.result.length > 0) {
				this.ruleList = res.result.map((rule) => {
					let obj = JSON.parse(rule.content || "");
					return {
						type: rule.type,
						title: obj.title,
						content: obj.content,
					};
				});
			}
		},
		async settlementCheck() {
			await api
				.settlement_check({
					orderType: 1,
					skus: this.checked,
				})
				.then((res) => {
					console.log(res);
				});
		},
		async getDefaultAddr() {
			await api.get_default_user_addr().then((res) => {

				this.addrId = res.result.id;
				let addr = res.result;
				
				let addrArr = [
					addr.address,
					addr.district,
					addr.city,
					addr.province,
					addr.postCode,
					addr.country,
				].filter(Boolean);

				this.addrText = addrArr.join(" ");

				this.getTickList();
			});
		},
		async action() {
			// let emailReg = new RegExp(/[\w\d]+@[\w\d]+\.[\w\d]+/g);
			// if (!this.dataForm.email || !emailReg.test(this.dataForm.email)) {
			//   this.$toast(this.$t("message.login.tips.yourEmail"));
			//   return;
			// }
			if (!this.en && !this.ruleChecked)
				return this.$toast("请先勾选同意告知书");
			if (!this.addrId) {
				this.showAddrList();
				return;
			} else if (!this.dataForm.payType) {
				this.showPayList();
				return;
			}

			let payCardId = null;

			if (this.dataForm.payType == 3) {
				if (!this.payMethod || !this.payMethod.id) {
					this.$toast("Please add a card");
					this.showAddCard();
					return;
				} else {
					payCardId = this.payMethod.id;
				}
			}

			let orderMerchandises = this.checked.map((good) => {
				return {
					...good,
					cartId: this.cartId || "",
					liveId: this.liveId,
					activityId: this.activityId || "",
				};
			});

			this.$loading("loading...");

			let ticketUserId = this.bestTicketInfo && this.bestTicketInfo.ticket ? this.bestTicketInfo.id : null;

			let couponCode = ticketUserId ? null : this.offCodeVal || null;

			let discountType = ticketUserId ? 1 : couponCode ? 2 : 0; // 优惠类型 0 不使用 1 优惠券 2 优惠码

			console.log(
				`ticketUserId:${ticketUserId},couponCode:${couponCode},discountType:${discountType}`
			);

			await api[ this.en ? 'save_order' : 'save_order_wechat']({
					orderAddrId: this.addrId,
					orderMerchandises,
					useCard: 0,
					discountType, // 优惠类型 0 不使用 1 优惠券 2 优惠码
					ticketUserId,
					couponCode,
					orderType: 1, // 订单类型 1 正常订单 2 拼团订单 3 筛子秒杀订单
					payType: this.dataForm.payType, // 订单支付方式 0 不选择支付方式 1 支付宝 2 微信支付 3 stripe 4 银联
					...this.someMoney,
					consigneeAddress: this.addrText,
					customerNote: this.dataForm.orderNote,
					payCardId,
					orderSource: 3, //订单来源 1 app 2 微信小程序 3 微信H5 ,
				})
				.then((res) => {

					this.$loading.close();

					if (res.code !== 0) {
						this.$toast(res.msg);
						return;
					}

					const {
						prePayInfo,
						toPayError,
						orderId,
						transactionNo,
					} = res.result;

					let fuc;
					
					if (this.dataForm.payType == 1) {
						fuc = "aliPayInfo";
					} else if (this.dataForm.payType == 2) {
						fuc = "wxpayWebPreInfo";
					} else if (this.dataForm.payType == 3) {
						if (toPayError) {
							this.$toast(this.$t("message.order.payError"));
							return;
						}
						const { stripePaymentResult = {} } = prePayInfo;
						const { clientSecret } = stripePaymentResult;
						if (!clientSecret) {
							this.$loading.close();
							this.return;
						}
						this.pay(clientSecret, transactionNo);
						return;
					} else {
						fuc = "nhpUnionPayInfo";
					}

					if( plateForm().isIOS ){
						document.write( prePayInfo[fuc] );
					}else{
						// ios可以这样 andorid用另外一种方式
						document.documentElement.innerHTML = prePayInfo[fuc];
						setTimeout(()=>{
							document.forms[0].submit();
						});
					}
				});
		},
		pay(secret, transactionNo) {
			// this.loadingToast(true);
			this.stripe
				.confirmCardPayment(secret, {
					setup_future_usage: "off_session",
				})
				.then((result) => {
					this.$loading.close();
					if (result.error) {
						// Show error to your customer
						// this.textToast('支付失败', message);
						// this.textToast(result.error.message);
						console.log(result.error.message);
					} else {
						if (result.paymentIntent.status === "succeeded") {
							// this.textToast('支付成功');
							// if(this.seStripe){ // 针对stripe支付 支付成功 重置支付参数
							//     this.getPay(null)
							// }
							console.log("支付成功");
							this.showPayResult();
						}
					}
					// this.goResult(transactionNo);
				})
				.catch((e) => {
					// this.goResult(transactionNo);
					// e && console.log('支付信息错误', e);
				});
		},
		changeRule() {
			this.ruleChecked = !this.ruleChecked;
		},
		showPayList() {
			this.payListShow = true;
		},
		choosePayType(type) {
			this.dataForm.payType = type;
			this.payListShow = false;
			if (type == 3 && !this.payMethod) {
				this.showAddCard();
			}
		},
		closePayList() {
			this.dataForm.payType = null;
			this.payListShow = false;
		},
		getActionText() {
			let text = "";
			if (!this.addrId) {
				text = this.$t("message.order.setAddr");
			} else if (!this.dataForm.payType) {
				text = this.$t("message.order.choosePay");
			} else {
				text = this.$t("message.order.pay");
			}
			return text;
		},
		showAddrList() {
			// this.$emit("chooseAddr");
			this.addressListShow = true;
		},
		async getCouponcode() {
			if (!this.offCodeVal) {
				this.$toast(this.$t("message.order.msg.promoCode"));
				return;
			}
			if (this.bestTicketInfo && this.bestTicketInfo.ticket) {
				this.$toast(this.$t("message.order.msg.uniquePromo"));
				this.offCodeVal = "";
				return;
			}
			// const merchandiseList = [
			//   {
			//     skuId: this.checked.skuId,
			//     merchandiseId: this.checked.id,
			//     liveId: this.liveId,
			//     num: 1,
			//     priceMoney: this.checked.miniAmountMoney,
			//   }
			// ];
			let params = {
				couponCode: this.offCodeVal,
				merchandiseList: this.checked,
				orderAddrId: this.addrId,
			};
			try {
				const { code, result, msg } = await api.choose_couponcode(
					params
				);
				if (!code) {
					this.someMoney = result;
				} else {
					this.$toast(msg);
					this.offCodeVal = "";
				}
			} catch (err) {
				console.error("fetch getCouponcode error:", err);
			}
		},
		getDiscountInfo(data) {
			console.log(data);
			this.couponView = false;
			this.ticketInfo = {
				bestUserTicketId: data.userTicketId,
				discountInfo: data.discountInfo,
			};
			// this.totalMoney = data.discountInfo.payAmountMoney;
			this.someMoney = data.discountInfo;
			// this.orderData = {
			//   ...data.discountInfo,
			//   totalAmountMoney: data.discountInfo.merchandiseAllMoney,
			//   disRankAmountMoney: data.discountInfo.disRankAmountMoney,
			//   disTicketAmountMoney: data.discountInfo.ticketSavePriceMoney,
			// };
			if (data.userTicketId) {
				const tmp = this.canUse.find((item) => {
					return item.id === data.userTicketId;
				});
				this.bestTicketInfo = { ...(tmp || null) };
				return;
			}
			this.bestTicketInfo = {};
		},
		// 获取默认最优优惠券
		async getTickList() {
			try {
				// const merchandiseList = [
				//   {
				//     skuId: this.checked.skuId,
				//     merchandiseId: this.checked.id,
				//     liveId: this.liveId,
				//     num: 1,
				//     priceMoney: this.checked.miniAmountMoney,
				//   }
				// ];
				let params = { merchandiseList: this.checked };
				if (this.addrId) {
					params.orderAddrId = this.addrId;
				}
				const { code, result, msg } = await api.get_ticket_list(params);

				if (!code) {

					const {
						bestTicketId,
						bestUserTicketId,
						discountInfo,
						canUse,
						cannotUse,
					} = result;
					
					if (!discountInfo) {
						this.block();
						return;
					}

					this.canUse = canUse;
					this.cannotUse = cannotUse;
					this.ticketInfo = {
						bestTicketId,
						bestUserTicketId,
						discountInfo,
					};
					this.someMoney = discountInfo;
					this.someMoneyReady = true;

					// this.orderData = {
					//   ...discountInfo,
					//   totalAmountMoney: discountInfo.merchandiseAllMoney,
					//   disRankAmountMoney: discountInfo.disRankAmountMoney,
					//   disTicketAmountMoney: discountInfo.ticketSavePriceMoney,
					// };
					if (canUse) {
						const tmp = this.canUse.find((item) => {
							return item.id === bestUserTicketId;
						});
						if (tmp) {
							this.bestTicketInfo = { ...tmp };
						} else {
							this.bestTicketInfo = null;
						}
					}
				} else {
					this.$toast(msg);
				}

			} catch (e) {
				console.error("fetch getUserCard error:", e);
				if (e.msg) {
					setTimeout(() => {
						this.$toast(e.msg);
					});
				}
			}
		},
		closeClick() {
			this.couponView = false;
		},
		couponClick() {
			// 底部弹出优惠券列表
			this.couponView = true;
		},
		async sub(index) {
			let good = this.checked[index];
			if (good.buyNum === 1)
				return this.$toast(this.$t("message.order.only"));
			this.$loading("loading...");
			good.buyNum = good.buyNum - 1;
			good.num = good.buyNum;
			this.checked.splice(index, 1, good);
			await this.getTickList();
			this.$loading.close();
		},
		async add(index) {
			this.$loading("loading...");
			let good = this.checked[index];
			good.buyNum = good.buyNum + 1;
			good.num = good.buyNum;
			this.checked.splice(index, 1, good);
			await this.getTickList();
			this.$loading.close();
		},
		block() {
			this.$toast("error");
			this.$emit("close");
		},
		getStripe(stripe) {
			this.stripe = stripe;
			console.log(stripe);
		},
		getPayMethod(payMethod) {
			this.payMethod = payMethod;
			console.log(payMethod);
		},
		showAddCard() {
			this.addCardShow = true;
		},
		closeAddCard() {
			this.addCardShow = false;
		},
		showPayResult() {
			this.payResultShow = true;
		},
		closePayResult() {
			this.payResultShow = false;
			this.orderShow = false;
		},
		// address
		newAddr() {
			this.editAddrId = "";
			this.addressInfoShow = true;
			this.addressListShow = false;
		},
		editAddr(id) {
			this.editAddrId = id;
			this.addressInfoShow = true;
			this.addressListShow = false;
		},
		async selectAddr(id, text) {
			this.$loading("loading...");
			this.addrId = id;
			this.addrText = text;
			await this.getTickList();
			this.$loading.close();
			this.addressListShow = false;
		},
		saveAddrSuccess(id) {
			this.addressInfoShow = false;
			this.addressListShow = true;
		},
		closeAddrInfo() {
			this.addressInfoShow = false;
		},
		closeAddrList() {
			this.addressListShow = false;
		},
		open(input = {}) {
			const { checked, liveId } = input;
			this.checked = checked;
			this.liveId = liveId;

			this.orderShow = true;
		},
		close() {
			this.orderShow = false;

			this.$order.close();
		},
	},
};
</script>

<style lang="less" scoped>
.warp() {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.node-desc() {
	height: 60px;
	line-height: 60px;
	font-size: 15px;
	font-weight: 600;
	color: #999999;
	> input {
		background: none;
		outline: none;
		border: none;
		color: #000000;
		width: 100%;
		&:focus {
			border: none;
		}
	}
	> input::-webkit-input-placeholder {
		color: #999999;
	}
}
.off-code-place() {
	font-weight: 400;
	color: rgba(143, 143, 143, 0.4);
}
.order {
	font-family: PingFangSC-Semibold, PingFang SC;
	&__panel {
		width: 100%;
		max-height: 96%;
		background: #ffffff;
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
		position: absolute;
		left: 0;
		bottom: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		box-shadow: 0 -1px 8px rgba(0, 0, 0, 0.1);
		z-index: 100;
	}
	&__header {
		height: 50px;
		width: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		> img {
			width: 26px;
			margin-right: 12px;
		}
	}
	&__body {
		flex: 1;
		width: 311px;
		margin: auto;
		text-align: left;
		scrollbar-width: none;
		-ms-overflow-style: none;
		overflow-x: hidden;
		overflow-y: auto;
		&::-webkit-scrollbar {
			display: none;
		}
	}
	&__good {
		&_unit {
			height: 100px;
			display: flex;
			align-items: flex-start;
			margin-bottom: 10px;
			&-top {
				margin-top: 20px;
			}
		}
		&_poster {
			width: 100px;
			height: 100px;
			border-radius: 8px;
			object-fit: cover;
			border: 1px solid #CCC;
		}
		&_info {
			width: 204.99px;
			font-family: PingFangSC-Semibold, PingFang SC;
			box-sizing: border-box;
			padding-left: 18px;
		}
		&_name {
			max-width: 200px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			font-size: 15px;
			font-weight: 600;
			color: #000000;
			line-height: 20px;
			margin-bottom: 5px;
		}
		&_price {
			margin-bottom: 8px;
			&-text {
				font-size: 20px;
				line-height: 18px;
				font-weight: 600;
				color: #345547;
			}
			&-off {
				height: 13px;
				line-height: 13px;
				font-size: 11px;
				font-weight: 600;
				color: #f66355;
			}
		}
		&_sku {
			max-width: 100%;
			font-size: 11px;
			font-weight: 600;
			color: #8a8a8f;
			line-height: 13px;
			margin-bottom: 8px;
		}
		&_inner {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
		}
		&__refund {
			height: 13px;
			line-height: 13px;
			font-size: 11px;
			font-weight: 600;
			color: #f66355;
		}
		&__num_area {
			width: 75px;
			height: 24px;
			background: #f3f5f9;
			border-radius: 14.49px;
			display: flex;
			font-weight: 500;
		}
		&__sub,
		&__add {
			width: 30px;
			height: 24px;
			line-height: 24px;
			text-align: center;
			color: #000000;
		}
		&__num {
			flex: 1;
			text-align: center;
			height: 24px;
			line-height: 24px;
			font-size: 15px;
			font-family: SFProText-Regular, SFProText;
			color: #000000;
		}
		&_desc {
			.node-desc;
		}
	}
	&__addr,
	&__off {
		&_icon {
			width: 22px;
			height: 22px;
			margin-left: 4px;
			margin-right: 12px;
		}
		&_text {
			width: 245px;
			height: 60px;
			line-height: 60px;
			font-size: 15px;
			font-weight: 600;
			color: #000000;
			text-align: left;
			> span.required {
				color: #f66355;
			}
		}
		&_arrow {
			width: 20px;
			height: 20px;
			margin-left: 4px;
		}
	}
	&__off_text {
		display: flex;
		justify-content: space-between;
		&_discount {
			color: #f66355;
		}
	}
	&__addr {
		width: 100%;
		height: 60px;
		display: flex;
		align-items: center;
		&_text {
			> span {
				display: inline-block;
				height: 100%;
				vertical-align: top;
			}
			> div {
				display: inline-block;
				max-width: 200px;
				.warp();
			}
		}
		&_placeholder {
			color: #999999;
		}
	}
	&__off {
		&_ticket {
			width: 100%;
			height: 60px;
			display: flex;
			align-items: center;
		}
		&_code {
			width: 100%;
			height: 60px;
			display: flex;
			align-items: center;
			> span {
				// width: 45px;
				font-size: 15px;
				font-weight: 600;
				color: #000000;
				margin-right: 12px;
			}
		}
		&_input {
			flex: 1;
			height: 28px;
			line-height: 28px;
			background: #f2f2f2;
			border-radius: 20px;
			display: flex;
			justify-content: center;
			align-items: center;
			> input {
				width: 142px;
				background: none;
				outline: none;
				border: none;
				&::-webkit-input-placeholder {
					.off-code-place;
				}
				&::-moz-placeholder {
					.off-code-place;
				}
				&:-ms-input-placeholder {
					.off-code-place;
				}
				&:-moz-placeholder {
					.off-code-place;
				}
			}
		}
		&_btn {
			width: 57.99px;
			height: 28px;
			line-height: 28px;
			text-align: center;
			margin-left: 12px;
			background: #222222;
			border-radius: 14px;
			color: #ffffff;
			font-size: 15px;
		}
		&_placeholder {
			color: #999999;
		}
	}
	&__note {
		.node-desc;
	}
	&__info {
		margin: 15px auto;
		&_item {
			width: 100%;
			height: 24px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 14px;
			font-weight: 400;
			color: #666666;
            .service-fee{
                display: flex;
                align-items: center;
                img{
                    width: 16px;
                    height: 16px;
                    margin-left: 5px;
                    vertical-align: top;
                }
            }
		}
	}
	&__rule {
		margin-top: 16px;
		width: 100%;
		overflow: hidden;
		display: flex;
		align-content: center;
		&_checkbox {
			width: 18px;
			height: 18px;
			margin-right: 8px;
			border: 1px solid #000000;
			border-radius: 7px;
		}
		&_text {
			flex: 1;
			max-width: 280px;
			font-size: 12px;
			font-weight: 400;
			color: #999999;
			line-height: 18px;
		}
	}
	&__total {
		width: 100%;
		height: 42px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		&_title {
			font-size: 15px;
			font-weight: 500;
			color: #333333;
		}
		&_val {
			font-size: 24px;
			font-weight: 600;
			color: #345547;
		}
	}
	&__btn {
		width: 100%;
		height: 46px;
		line-height: 46px;
		text-align: center;
		margin-top: 24px;
		margin-bottom: 24px;
		background: #222222;
		font-size: 15px;
		font-family: Helvetica;
		color: #ffffff;
		border-radius: 23px;
	}
	&__rule_pop {
		margin-top: 50px;
		background: #000000;
		max-height: 320px;
		overflow-y: scroll;
	}
}
</style>
